import router from "@/router";
import { ls } from "@/CommonVueCore/src/services/secureLs/secure";
import { Complex } from "@/CommonVueCore/src/constants/globalEnums/Complex";
import { defineStore } from "pinia";
import { jwtDecode } from "jwt-decode";
import { AuthService } from "@/services/authService/authService.js";

export const useAuthAppStore = defineStore("authStore", {
  state: () => ({
    userAuthInfo: null,
    token: null,
    parsedToken: null,
    selectedComplex: null,
    ComplexesByUserName: null,
    allComplexes: null,
  }),
  getters: {
    getParsedToken() {
      return this.parsedToken;
    },
    getUserAuthState() {
      return this.userAuthInfo;
    },
    getCheckExpired() {
      return new AuthService().checkExpired(this.parsedToken);
    },
    getSelectedComplex() {
      return this.selectedComplex;
    },
    getSelectedComplexDescription() {
      // 1. Try to find in dynamic list (fetched from API)
      if (this.ComplexesByUserName && this.ComplexesByUserName.length > 0) {
        const dynamicMatch = this.ComplexesByUserName.find(
          (item) => item.PKey == this.selectedComplex
        );
        if (dynamicMatch) return dynamicMatch.Name;
      }

      // 2. Fallback to static Complex enum
      const allCategories = Object.values(Complex).flat();
      const match = allCategories.find(
        (item) => item.code === parseInt(this.selectedComplex)
      );

      return match ? match.description : window.$t("Description_Not_Found");
    },
    getComplexDescriptionByCode() {
      return (code) => {
        if (this.ComplexesByUserName && this.ComplexesByUserName.length > 0) {
          const dynamicMatch = this.ComplexesByUserName.find(
            (item) => item.PKey == code
          );
          if (dynamicMatch) return dynamicMatch.Name;
        }

        const allCategories = Object.values(Complex).flat();
        const match = allCategories.find(
          (item) => item.code === parseInt(code)
        );

        return match ? match.description : window.$t("Description_Not_Found");
      };
    },
    getComplexesByUserName() {
      return this.ComplexesByUserName;
    },
  },
  actions: {
    setLogin({ data }) {
      //token oluştur

      //keycloak a git ve token ı al.
      this.token = data.bearerToken; //değişecek
      console.log("setlogin", data);

      var authInfo = new AuthService().parseToken({ data: data });
      if (authInfo.isAuthentication) {
        this.setParsedTokenInfo(authInfo.parsedToken);
        this.setUserAuthState(authInfo);
      }
    },
    setReLogin({ data }){
      this.token = data.bearerToken;

      var authInfo = new AuthService().parseReLoginToken({ data: data });
      if (authInfo.isAuthentication) {
        this.setParsedTokenInfo(authInfo.parsedToken);
        this.setUserAuthState(authInfo);
      }
    },
    setParsedTokenInfo(userInfo) {
      this.parsedToken = userInfo;
    },
    setUserAuthState(userAuthInfo) {
      this.userAuthInfo = userAuthInfo;
    },
    setSelectedComplex(selectedComplex) {
      this.selectedComplex = selectedComplex;
    },
    setResetParsedToken() {
      this.parsedToken = null;
    },
    setResetToken() {
      this.token = null;
    },
    setLogOut() {
      this.clearCurrentState();
    },
    clearCurrentState() {
      //Dinamik olarak state te tanımlanan verileri çeker. Sonraısnda her birini null a veya false a çeker.
      //Böylelikle state içine tanımladığımız her state değerini clear larkenki methoda yazmamız gerekmez. Dinamik sıfırlanır
      for (let index = 0; index < Object.entries(this.$state).length; index++) {
        var stateName = Object.entries(this.$state)[index][0];

        var stateType = typeof Object.entries(this.$state)[index][1];
        if (stateType === "boolean") {
          this[stateName] = false;
        } else {
          this[stateName] = null;
        }
      }
    },
    setComplexesByUserName(_complexes) {
      this.ComplexesByUserName = _complexes;
    },
    setAllComplexes(_allComplexes) {
      this.allComplexes = _allComplexes;
    },
    checkExpiredNow() {
      return new AuthService().checkExpired(this.parsedToken);
    },
  },
  persist: {
    storage: {
      getItem: function (key) {
        try {
          return ls.get(key);
        } catch (err) {
          localStorage.clear();
          router.push({ name: "login" });
        }
      },
      setItem: (key, value) => ls.set(key, value),
      removeItem: (key) => ls.remove(key),
    },
  },
});
